export const QUERY = `
query isRovoEnabledQuery($cloudId: ID!, $shouldShowRovoLLMEnabled: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldShowRovoLLMEnabled)
}
`;
